// Mock knowledge base documents
export const mockKnowledgeBase = [
  // ========== PRODUCT CARDS (15 items) ==========
  {
    id: "kb-1",
    title: "Тушь для ресниц Volume",
    document_type: "product_info",
    content: "Тушь для ресниц Volume создает прозрачное покрытие, придавая ресницам объем и длину. Водостойкая формула обеспечивает стойкость в течение всего дня. Не осыпается, не размазывается. Идеально подходит для создания выразительного взгляда.",
    product_info: {
      seller_sku: "040955",
      wb_sku: "56184727",
      category: "Туши",
      color: "черный",
      barcode: "4607154721234",
    },
    tags: ["art-visage", "тушь", "черный", "volume", "водостойкая"],
    metadata: {
      brand: "Art-Visage",
      group: 1,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T10:00:00Z",
    updated_at: "2025-10-15T10:00:00Z",
  },
  {
    id: "kb-2",
    title: "Пудра для лица матирующая прозрачная INVISIBLE",
    document_type: "product_info",
    content: "Матирующая пудра с невидимым покрытием. Выравнивает тон кожи, скрывает недостатки, придает коже бархатистость. Подходит для всех типов кожи. Не забивает поры.",
    product_info: {
      seller_sku: "068126",
      wb_sku: "74059046",
      category: "Пудры",
      color: "прозрачный",
      barcode: "4607154728912",
    },
    tags: ["estrade", "пудра", "матирующая", "invisible"],
    metadata: {
      brand: "Estrade",
      group: 2,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T10:05:00Z",
    updated_at: "2025-10-15T10:05:00Z",
  },
  {
    id: "kb-3",
    title: "Блеск для губ с эффектом объема Lip Gloss",
    document_type: "product_info",
    content: "Блеск для губ с зеркальным эффектом и 3D объемом. Содержит витамин Е и масла, которые увлажняют и питают губы. Не липнет, не растекается. Приятный аромат ванили.",
    product_info: {
      seller_sku: "052341",
      wb_sku: "81234567",
      category: "Блески",
      color: "розовый",
      barcode: "4607154734567",
    },
    tags: ["art-visage", "блеск", "губы", "объем"],
    metadata: {
      brand: "Art-Visage",
      group: 3,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T10:10:00Z",
    updated_at: "2025-10-15T10:10:00Z",
  },
  {
    id: "kb-4",
    title: "Тональный крем Perfect Skin",
    document_type: "product_info",
    content: "Тональный крем с эффектом второй кожи. Легкая текстура обеспечивает равномерное покрытие, скрывает недостатки. SPF 15 защищает от солнца. Подходит для ежедневного использования.",
    product_info: {
      seller_sku: "063245",
      wb_sku: "92345678",
      category: "Тональные средства",
      color: "бежевый",
      barcode: "4607154745678",
    },
    tags: ["estrade", "тональный-крем", "spf15", "perfect-skin"],
    metadata: {
      brand: "Estrade",
      group: 1,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T10:15:00Z",
    updated_at: "2025-10-15T10:15:00Z",
  },
  {
    id: "kb-5",
    title: "Карандаш для бровей Brow Pencil",
    document_type: "product_info",
    content: "Карандаш для бровей с щеточкой. Мягкая текстура позволяет легко нарисовать естественные брови. Стойкая формула держится весь день. Не растекается.",
    product_info: {
      seller_sku: "074567",
      wb_sku: "10345678",
      category: "Брови",
      color: "коричневый",
      barcode: "4607154756789",
    },
    tags: ["art-visage", "брови", "карандаш", "коричневый"],
    metadata: {
      brand: "Art-Visage",
      group: 2,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T10:20:00Z",
    updated_at: "2025-10-15T10:20:00Z",
  },
  {
    id: "kb-6",
    title: "Помада матовая Matte Lipstick",
    document_type: "product_info",
    content: "Матовая помада с бархатной текстурой. Насыщенный цвет в одно касание. Не сушит губы благодаря витаминам в составе. Стойкость до 8 часов.",
    product_info: {
      seller_sku: "085678",
      wb_sku: "11456789",
      category: "Помады",
      color: "красный",
      barcode: "4607154767890",
    },
    tags: ["art-visage", "помада", "матовая", "красный"],
    metadata: {
      brand: "Art-Visage",
      group: 3,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T10:25:00Z",
    updated_at: "2025-10-15T10:25:00Z",
  },
  {
    id: "kb-7",
    title: "Консилер под глаза Perfect Cover",
    document_type: "product_info",
    content: "Консилер для маскировки темных кругов под глазами. Легкая текстура не забивается в складки. Содержит гиалуроновую кислоту для увлажнения нежной кожи.",
    product_info: {
      seller_sku: "096789",
      wb_sku: "12567890",
      category: "Консилеры",
      color: "светлый-бежевый",
      barcode: "4607154778901",
    },
    tags: ["estrade", "консилер", "под-глаза", "perfect-cover"],
    metadata: {
      brand: "Estrade",
      group: 1,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T10:30:00Z",
    updated_at: "2025-10-15T10:30:00Z",
  },
  {
    id: "kb-8",
    title: "Палетка теней для век Natural Eyes",
    document_type: "product_info",
    content: "Палетка из 9 натуральных оттенков для создания дневного и вечернего макияжа. Легко растушевываются, не осыпаются. Матовые и сатиновые текстуры.",
    product_info: {
      seller_sku: "107890",
      wb_sku: "13678901",
      category: "Тени",
      color: null,
      barcode: "4607154789012",
    },
    tags: ["art-visage", "тени", "палетка", "natural"],
    metadata: {
      brand: "Art-Visage",
      group: 2,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T10:35:00Z",
    updated_at: "2025-10-15T10:35:00Z",
  },
  {
    id: "kb-9",
    title: "Подводка для глаз Liquid Liner",
    document_type: "product_info",
    content: "Жидкая подводка с тонкой кисточкой для точных линий. Насыщенный черный цвет. Водостойкая формула держится до 12 часов. Не размазывается.",
    product_info: {
      seller_sku: "118901",
      wb_sku: "14789012",
      category: "Подводки",
      color: "черный",
      barcode: "4607154790123",
    },
    tags: ["estrade", "подводка", "liquid-liner", "водостойкая"],
    metadata: {
      brand: "Estrade",
      group: 3,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T10:40:00Z",
    updated_at: "2025-10-15T10:40:00Z",
  },
  {
    id: "kb-10",
    title: "Румяна для лица Blush",
    document_type: "product_info",
    content: "Компактные румяна с шелковистой текстурой. Придают коже естественный румянец и свежий вид. Легко растушевываются, не скатываются.",
    product_info: {
      seller_sku: "129012",
      wb_sku: "15890123",
      category: "Румяна",
      color: "персиковый",
      barcode: "4607154801234",
    },
    tags: ["art-visage", "румяна", "персиковый", "blush"],
    metadata: {
      brand: "Art-Visage",
      group: 1,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T10:45:00Z",
    updated_at: "2025-10-15T10:45:00Z",
  },
  {
    id: "kb-11",
    title: "Праймер для лица Hydra Primer",
    document_type: "product_info",
    content: "Увлажняющий праймер под макияж. Выравнивает текстуру кожи, обеспечивает стойкость макияжа на весь день. Содержит гиалуроновую кислоту и витамин Е.",
    product_info: {
      seller_sku: "130123",
      wb_sku: "16901234",
      category: "Праймеры",
      color: null,
      barcode: "4607154812345",
    },
    tags: ["estrade", "праймер", "hydra", "увлажняющий"],
    metadata: {
      brand: "Estrade",
      group: 2,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T10:50:00Z",
    updated_at: "2025-10-15T10:50:00Z",
  },
  {
    id: "kb-12",
    title: "Гель для бровей Brow Gel",
    document_type: "product_info",
    content: "Прозрачный гель для фиксации бровей. Держит форму весь день, не склеивает волоски. Не оставляет белых следов. Подходит для всех оттенков бровей.",
    product_info: {
      seller_sku: "141234",
      wb_sku: "17012345",
      category: "Брови",
      color: "прозрачный",
      barcode: "4607154823456",
    },
    tags: ["art-visage", "гель", "брови", "фиксация"],
    metadata: {
      brand: "Art-Visage",
      group: 3,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T10:55:00Z",
    updated_at: "2025-10-15T10:55:00Z",
  },
  {
    id: "kb-13",
    title: "Хайлайтер Glow Highlighter",
    document_type: "product_info",
    content: "Хайлайтер с эффектом сияния. Придает коже здоровое свечение. Легкая шелковистая текстура. Можно использовать на скулах, спинке носа, под бровью.",
    product_info: {
      seller_sku: "152345",
      wb_sku: "18123456",
      category: "Хайлайтеры",
      color: "золотистый",
      barcode: "4607154834567",
    },
    tags: ["estrade", "хайлайтер", "glow", "золотистый"],
    metadata: {
      brand: "Estrade",
      group: 1,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T11:00:00Z",
    updated_at: "2025-10-15T11:00:00Z",
  },
  {
    id: "kb-14",
    title: "Карандаш для глаз Eye Pencil",
    document_type: "product_info",
    content: "Мягкий карандаш для глаз с насыщенным цветом. Легко растушевывается для создания smoky eyes. Водостойкая формула держится до 10 часов.",
    product_info: {
      seller_sku: "163456",
      wb_sku: "19234567",
      category: "Карандаши для глаз",
      color: "черный",
      barcode: "4607154845678",
    },
    tags: ["art-visage", "карандаш", "глаза", "черный"],
    metadata: {
      brand: "Art-Visage",
      group: 2,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T11:05:00Z",
    updated_at: "2025-10-15T11:05:00Z",
  },
  {
    id: "kb-15",
    title: "Фиксатор макияжа Setting Spray",
    document_type: "product_info",
    content: "Спрей для фиксации макияжа. Обеспечивает стойкость до 16 часов. Освежает кожу, не оставляет пленки. Подходит для всех типов кожи.",
    product_info: {
      seller_sku: "174567",
      wb_sku: "20345678",
      category: "Фиксаторы",
      color: null,
      barcode: "4607154856789",
    },
    tags: ["estrade", "фиксатор", "setting-spray", "стойкость"],
    metadata: {
      brand: "Estrade",
      group: 3,
      source: "product_card_import"
    },
    is_indexed: true,
    created_at: "2025-10-15T11:10:00Z",
    updated_at: "2025-10-15T11:10:00Z",
  },

  // ========== FAQ DOCUMENTS (5 items) ==========
  {
    id: "kb-16",
    title: "Как вернуть товар",
    document_type: "faq",
    content: `Возврат товара возможен в течение 14 дней с момента покупки.

Условия возврата:
1. Товар не был в употреблении
2. Сохранена упаковка и все этикетки
3. Есть чек или подтверждение заказа

Для оформления возврата:
- Свяжитесь с нами через форму обратной связи
- Укажите номер заказа
- Опишите причину возврата

Возврат средств осуществляется в течение 5-10 рабочих дней.`,
    tags: ["возврат", "faq", "политика"],
    metadata: {
      topic: "refund",
      priority: "high"
    },
    is_indexed: true,
    created_at: "2025-10-10T14:00:00Z",
    updated_at: "2025-10-10T14:00:00Z",
  },
  {
    id: "kb-17",
    title: "Как выбрать оттенок тонального крема",
    document_type: "faq",
    content: `Выбор правильного оттенка тонального крема:

1. Определите подтон кожи:
   - Теплый: желтоватый, золотистый оттенок
   - Холодный: розоватый, синеватый оттенок
   - Нейтральный: смесь теплого и холодного

2. Тестируйте оттенок на линии подбородка, а не на руке
3. Проверьте при дневном свете
4. Тональный крем должен сливаться с кожей шеи

Наши рекомендации:
- Светлая кожа: оттенки 01-02
- Средняя кожа: оттенки 03-04
- Темная кожа: оттенки 05-06`,
    tags: ["тональный-крем", "faq", "подбор-оттенка"],
    metadata: {
      topic: "product_selection",
      priority: "high"
    },
    is_indexed: true,
    created_at: "2025-10-10T14:30:00Z",
    updated_at: "2025-10-10T14:30:00Z",
  },
  {
    id: "kb-18",
    title: "Срок годности косметики",
    document_type: "faq",
    content: `Срок годности различных видов косметики:

Тушь для ресниц: 3-6 месяцев после открытия
Тональный крем: 12 месяцев
Пудра: 24 месяца
Помада: 12-18 месяцев
Тени для век: 12-24 месяца
Карандаши: 12-24 месяца

Признаки испорченной косметики:
- Изменение запаха
- Изменение текстуры
- Расслоение
- Изменение цвета

Храните косметику в прохладном сухом месте, вдали от прямых солнечных лучей.`,
    tags: ["срок-годности", "faq", "хранение"],
    metadata: {
      topic: "product_care",
      priority: "medium"
    },
    is_indexed: true,
    created_at: "2025-10-10T15:00:00Z",
    updated_at: "2025-10-10T15:00:00Z",
  },
  {
    id: "kb-19",
    title: "Аллергия на косметику - что делать",
    document_type: "faq",
    content: `Если у вас появились признаки аллергической реакции:

1. Немедленно прекратите использование продукта
2. Смойте косметику водой
3. Не наносите другие средства на пораженную область
4. Примите антигистаминное средство
5. Обратитесь к врачу при серьезной реакции

Профилактика:
- Проводите патч-тест перед первым использованием
- Наносите небольшое количество на сгиб локтя
- Ждите 24 часа
- Изучайте состав перед покупкой

Мы используем гипоаллергенные компоненты, но индивидуальная непереносимость возможна.`,
    tags: ["аллергия", "faq", "здоровье"],
    metadata: {
      topic: "health",
      priority: "critical"
    },
    is_indexed: true,
    created_at: "2025-10-10T15:30:00Z",
    updated_at: "2025-10-10T15:30:00Z",
  },
  {
    id: "kb-20",
    title: "Доставка и оплата",
    document_type: "faq",
    content: `Информация о доставке и оплате:

Способы доставки:
- Курьерская доставка (1-3 дня)
- Почта России (5-10 дней)
- Пункт выдачи заказов (3-5 дней)

Стоимость доставки:
- Бесплатно при заказе от 2000 руб
- 200-400 руб в зависимости от региона

Способы оплаты:
- Банковская карта
- Наложенный платеж
- Электронные кошельки
- СБП

Оплата безопасна и защищена.`,
    tags: ["доставка", "оплата", "faq"],
    metadata: {
      topic: "shipping",
      priority: "high"
    },
    is_indexed: true,
    created_at: "2025-10-10T16:00:00Z",
    updated_at: "2025-10-10T16:00:00Z",
  },

  // ========== TONE OF VOICE (3 items) ==========
  {
    id: "kb-21",
    title: "Tone of Voice - Профессиональный стиль",
    document_type: "tone_of_voice",
    content: `Профессиональный стиль ответов на отзывы:

Характеристики:
- Официальный, но не холодный тон
- Грамотная речь без разговорных выражений
- Четкая структура ответа
- Конкретика без воды

Примеры обращений:
✓ "Добрый день"
✓ "Здравствуйте"
✗ "Привет"
✗ "Хай"

Как благодарить:
✓ "Благодарим за ваш отзыв"
✓ "Спасибо за обратную связь"
✗ "Спасибки"
✗ "Благодарочка"

Подпись:
"С уважением, Art-Visage"
"С наилучшими пожеланиями, команда Estrade"`,
    tags: ["tone-of-voice", "профессиональный", "стиль"],
    metadata: {
      style: "professional",
      priority: "high"
    },
    is_indexed: true,
    created_at: "2025-10-08T10:00:00Z",
    updated_at: "2025-10-08T10:00:00Z",
  },
  {
    id: "kb-22",
    title: "Tone of Voice - Заботливый стиль",
    document_type: "tone_of_voice",
    content: `Заботливый стиль ответов на отзывы:

Характеристики:
- Теплый, эмоциональный тон
- Проявление эмпатии
- Персонализация
- Использование смягчающих конструкций

Примеры:
✓ "Нам очень жаль, что так получилось"
✓ "Мы понимаем ваше разочарование"
✓ "Ваше мнение очень важно для нас"

Эмодзи (умеренно):
✓ "Спасибо! 💕"
✓ "Рады помочь! ✨"
✗ "Ой-ой-ой!!! 😱😱😱"

Подпись:
"С заботой, Art-Visage 🌸"
"С любовью, команда Estrade 💖"`,
    tags: ["tone-of-voice", "заботливый", "эмпатия"],
    metadata: {
      style: "caring",
      priority: "high"
    },
    is_indexed: true,
    created_at: "2025-10-08T10:30:00Z",
    updated_at: "2025-10-08T10:30:00Z",
  },
  {
    id: "kb-23",
    title: "Tone of Voice - Дружелюбный стиль",
    document_type: "tone_of_voice",
    content: `Дружелюбный стиль ответов на отзывы:

Характеристики:
- Легкий, неформальный тон
- Позитивный настрой
- Простые понятные формулировки
- Личное обращение

Примеры:
✓ "Как здорово, что вам понравилось!"
✓ "Будем рады видеть вас снова!"
✓ "Спасибо, что поделились впечатлениями!"

Обращение к покупателю:
✓ По имени: "Мария, спасибо за отзыв!"
✓ "Дорогой покупатель"
✗ Слишком фамильярно: "Маш, привет!"

Подпись:
"С теплом, Art-Visage! ☺️"
"До новых встреч, Estrade!"`,
    tags: ["tone-of-voice", "дружелюбный", "позитив"],
    metadata: {
      style: "friendly",
      priority: "medium"
    },
    is_indexed: true,
    created_at: "2025-10-08T11:00:00Z",
    updated_at: "2025-10-08T11:00:00Z",
  },

  // ========== POLICY (2 items) ==========
  {
    id: "kb-24",
    title: "Политика обработки персональных данных",
    document_type: "policy",
    content: `Политика конфиденциальности Art-Visage / Estrade

Мы собираем следующие данные:
- Имя, фамилия
- Адрес электронной почты
- Телефон
- Адрес доставки
- История заказов

Как мы используем данные:
- Обработка заказов
- Доставка товаров
- Информирование о статусе заказа
- Маркетинговые коммуникации (с вашего согласия)

Защита данных:
- SSL-шифрование
- Ограниченный доступ сотрудников
- Регулярные проверки безопасности

Ваши права:
- Доступ к своим данным
- Исправление данных
- Удаление данных
- Отказ от рассылок

Срок хранения: 5 лет с момента последнего заказа.`,
    tags: ["политика", "персональные-данные", "конфиденциальность"],
    metadata: {
      document_category: "legal",
      priority: "high"
    },
    is_indexed: true,
    created_at: "2025-10-05T09:00:00Z",
    updated_at: "2025-10-20T14:00:00Z",
  },
  {
    id: "kb-25",
    title: "Политика возврата и обмена",
    document_type: "policy",
    content: `Условия возврата и обмена товара:

Сроки:
- 14 дней с момента получения товара
- Товар не должен быть в употреблении

Что можно вернуть:
✓ Товары ненадлежащего качества
✓ Товары с браком
✓ Товары, не подошедшие по цвету/оттенку
✗ Вскрытую косметику (по санитарным нормам)

Процедура:
1. Свяжитесь с нами через форму
2. Отправьте фото товара и чека
3. Получите инструкции по возврату
4. Отправьте товар обратно
5. Получите возврат средств

Возврат денег:
- На банковскую карту: 5-10 дней
- На электронный кошелек: 3-5 дней

Обмен товара:
Возможен при наличии товара на складе.`,
    tags: ["возврат", "обмен", "политика"],
    metadata: {
      document_category: "legal",
      priority: "critical"
    },
    is_indexed: true,
    created_at: "2025-10-05T09:30:00Z",
    updated_at: "2025-10-20T14:30:00Z",
  },
];
